// src/utils/date.js
// Utilidades simples para formatear fechas entre DD/MM/AAAA (vista) y YYYY-MM-DD (API).
import { fechaIsoLocal } from './fechaLocal.mjs';

function pad(value) {
  return String(value).padStart(2, '0');
}

export function normalizeDateDigits(value) {
  return String(value || '').replace(/\D/g, '').slice(0, 8);
}

export function applyDateMask(value) {
  const digits = normalizeDateDigits(value);
  if (digits.length <= 2) return digits;
  if (digits.length <= 4) return `${digits.slice(0, 2)}/${digits.slice(2)}`;
  return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
}

export function toDisplayDate(value) {
  if (!value) return '';
  if (typeof value === 'string' && /^\d{2}\/\d{2}\/\d{4}$/.test(value.trim())) return value.trim();
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value.trim())) {
    const [year, month, day] = value.trim().split('-');
    return `${day}/${month}/${year}`;
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return applyDateMask(value);
  return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()}`;
}

export function toApiDate(displayValue) {
  if (!displayValue) return '';
  if (typeof displayValue === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(displayValue.trim())) {
    return displayValue.trim();
  }
  const parts = displayValue.split('/');
  if (parts.length !== 3) return '';
  const [day, month, year] = parts.map(p => parseInt(p, 10));
  if (!day || !month || !year) return '';
  const isoCandidate = new Date(year, month - 1, day);
  if (
    Number.isNaN(isoCandidate.getTime()) ||
    isoCandidate.getDate() !== day ||
    isoCandidate.getMonth() !== month - 1 ||
    isoCandidate.getFullYear() !== year
  ) {
    return '';
  }
  return `${isoCandidate.getFullYear()}-${pad(isoCandidate.getMonth() + 1)}-${pad(isoCandidate.getDate())}`;
}

export function todayDisplay() {
  const now = new Date();
  return `${pad(now.getDate())}/${pad(now.getMonth() + 1)}/${now.getFullYear()}`;
}

// Delega en `fechaIsoLocal`: una sola copia del cálculo de «hoy» local
// (FIX_HALLAZGOS_DE_VERIFICACION_v0.1.md, F-1).
export function todayApi() {
  return fechaIsoLocal();
}
